import { render, staticRenderFns } from "./ReportCreate.vue?vue&type=template&id=631e624b&scoped=true"
import script from "./ReportCreate.vue?vue&type=script&lang=js"
export * from "./ReportCreate.vue?vue&type=script&lang=js"
import style0 from "./ReportCreate.vue?vue&type=style&index=0&id=631e624b&prod&lang=scss"
import style1 from "./ReportCreate.vue?vue&type=style&index=1&id=631e624b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631e624b",
  null
  
)

export default component.exports